import type { RouteRecordRaw } from "vue-router";

export const localeRoutes: RouteRecordRaw[] = [
  {
    path: "/:locale/help",
    component: () => import("./HelpLayout.vue"),
    children: [
      {
        path: "",
        name: "help-index",
        component: () => import("./help/LocaleHelpPage.vue"),
      },
      {
        path: "articles/:id-:slug",
        name: "help-article-show",
        component: () =>
          import("./help/articles/[id]-[slug]/HelpArticleDetailPage.vue"),
      },
      {
        path: "categories/:id-:slug",
        name: "help-category-show",
        component: () =>
          import("./help/categories/[id]-[slug]/HelpCategoryDetailPage.vue"),
      },
      {
        path: "search",
        name: "help-search-show",
        component: () => import("./help/search.vue"),
      },
    ],
  },
];
